<template>
    <div class="courseBox flexCol">
        <div class="top">
            <div class="campusBox rowAc" @click="showPicker = true">
                <div>{{campus}}</div>
                <div class="icon" :class="[showPicker? 'icon-arrow-up':'icon-arrow-down']"></div>
            </div>
            <img src="../../assets/static/courseMan.svg" alt="" class="topImg">
            <div class="goToday" @click="getToday" v-if="!isToday">返回今天</div>
        </div>
         <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                show-toolbar
                ref="selectCampus"
                :columns="campusNames"
                :default-index="campusIdx"
                @cancel="showPicker = false"
                @confirm="selectCampusConfirm"
            />
        </van-popup>
        <div class="calendarBox">
            <calendar :markDays="markDays" @changeMonth="changeMonth" :selectDate="selectDate" @setDate="setDate"></calendar>
        </div>
        <div class="courseList">
            <div class="emptyBox colAc" v-if="courseList.length == 0">
                <img src="../../assets/static/emptyList.png" alt="">
                <div>暂时还没有课程哦</div>
            </div>
            <div class="courseItem flexRow" v-for="(item,index) in courseList" :key="index">
                <div class="time rowAc" :class="[index != 0 ? 'paddT':'']">{{item.timeInterval.split(' ')[1]}}</div>
                <div class="courseInfo" :class="[index != 0 ? 'paddT':'']">
                    
                    <div class="infoBox colJb" :class="[item.isSelf ? 'self':'common']"  @click="clickItem(item)">
                        <div class="spotBox rowAc">
                            <div class="spot"></div>
                        </div>
                        <div class="courseName textOver">{{item.className}}</div>
                        <div class="infoText flexRow"><div class="attribute">上课老师</div> <div class="value">{{item.teacherName}}</div></div>
                        <div class="infoText flexRow"><div class="attribute">上课时间</div> <div class="value">{{item.timeInterval}}</div></div>
                        <!-- <div class="infoText flexRow"><div class="attribute">上课学生</div> <div class="value">{{item.studentName}}</div></div> -->
                        <div class="infoText flexRow"><div class="attribute">上课教室</div> <div class="value">{{item.classroomName}}</div></div>
                        <div class="infoText flexRow"><div class="attribute flexRow">助<div class="empty">助教</div>教</div><div class="value textOver">{{item.assistantTeachers}}</div></div>
                        <div class="infoText flexRow"><div class="attribute flexRow">主<div class="empty">主题</div>题</div><div class="value textOver">{{item.title}}</div></div>
                        <div class="infoText flexRow"><div class="attribute">循环方式</div> <div class="value">{{loopType[item.loopType]}}</div></div>
                        <div class="infoText flexRow"><div class="attribute">上课人数</div> <div class="value">{{item.students}}</div></div>
                        <!-- <div class="attendanceStatusBox rowJcAc">{{attendanceStatus[item.attendanceStatus].text}}</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getCourseDataAPI,getCourseDetailsAPI,getInstitutionCampusAPI,getAuthsRefreshAPI} from '../../utils/api/api'
import calendar from "../../components/Course/calendar.vue"
export default {
    data() {
        return {
            markDays: [
                {date: '2020-11-01',isSelf: 1},
                {date: '2020-11-03',isSelf: 0},
                {date: '2020-11-28',isSelf: 1},
                {date: '2020-12-01',isSelf: 0},
                {date: '2020-12-02',isSelf: 1},
            ],
            // markDays: ['2020-11-01','2020-11-02','2020-11-28','2020-12-01'],
            selectDate: '',
            campus: '',
            campusCode: '',
            parentUid: '',

            showPicker: false,
            campusNames: [],
            campusList: [],
            year: '',
            month: '',

            attendanceStatus: {
                4: {bgc:"unregistered", text: '未登记'}, // 未登录
                0: {bgc: "common",text: '正常'}, // 正常
                3: {bgc: "vacate",text: '请假'}, // 请假
                2: {bgc: "truant",text: '旷课'}, // 旷课
                // 1: {bgc: "late",text: '迟到'}, // 
                5: {bgc: "nomend",text: '待补课'}, //
                6: {bgc: "arrange",text: '已安排'}, // 
                7: {bgc: "mend",text: '已补课'}, // 
                8: {bgc: "pass",text: '已过期'}, // 
            },
            courseData: {},
            courseList: [
                // {
                //     assistantTeachers: null,
                //     className: "霹雳舞普通A班",
                //     classroomName: "修魔课堂",
                //     id: 5,
                //     isSelf: 0,
                //     loopType: 1,
                //     students: 1,
                //     teacherName: "猪八戒",
                //     timeInterval: "2020-11-22 08:00 ~ 08:45",
                //     title: "霹雳舞",
                // }
            ],
            loopType: {
                0: '不循环',
                1: '周循环',
                2: '月循环'
            },
            dates: []
        }
    },
    computed: {
        // 选中校区的id
        campusIdx() {
           return this.campusNames.findIndex(item => {return item == this.campus})
        },
        isToday() {
            let date = new Date()
            let y = date.getFullYear();
            let m = date.getMonth();
            let d = date.getDate();
            return this.selectDate == y+'-'+this.changeNum(m+1)+'-'+this.changeNum(d)
        },
    },
    components: {calendar},
    created() {
        if(this.$common.getCache('institutionCode')) {
            this.campusNames = []
            var institutionCode = this.$common.getCache('institutionCode')
            
            getInstitutionCampusAPI({code: institutionCode}).then(res => {
                console.log('校区列表：',res)
                if(res.resultCode == 200 && res.data) {
                    res.data.forEach(item => {
                        this.campusNames.push(item.name)
                        if(this.$common.getCache('campusCode')) {
                            if(item.code == this.$common.getCache('campusCode')) {
                                this.campus = item.name
                                this.campusCode = item.code
                            }
                        }
                        this.campusList.push({
                            campusName: item.name,
                            campusCode: item.code
                        })
                    })
                    
                }
            })
        }
        // if(window.localStorage.getItem('customerAuthList')) {
        //     this.campusList = JSON.parse(window.localStorage.getItem('customerAuthList'))
        //     this.campusNames = []
        //     this.campusList.forEach((item) => {
        //         if(localStorage.getItem('campusCode')) {
        //             if(item.campusCode == localStorage.getItem('campusCode')) {
        //                 this.campus = item.campusName
        //                 this.campusCode = item.campusCode
        //             }
        //         }
                
        //         this.campusNames.push(item.campusName)
        //     })
        // }
        
        this.getToday()
    },
    watch: {
        selectDate() {
            this.getDetail()
        },
        // 取消选中 校区时选中索引改为当前选中
        showPicker() {
            if(!this.showPicker) {
                this.$refs.selectCampus.setIndexes([this.campusIdx])
            }
        }
    },
    // 进入学生列表页面时缓存当前页面
    beforeRouteLeave(to,from,next) {
        if(to.path == '/stuList') {
            from.meta.keepAlive = true
            next()
        }else {
            from.meta.keepAlive = false
            next()
        }
    },
    methods: {
        // 选择校区确认
        async selectCampusConfirm(value) {
            this.showPicker = false;
            if(this.campus == value) {
                return
            }
            this.campus = value;
            this.campusCode = this.campusList[this.campusIdx].campusCode
            var res = await getAuthsRefreshAPI({campusCode:this.campusCode})
            if(res.resultCode == 200) {
                // localStorage.setItem('campusCode',res.data.campusCode)
                // localStorage.setItem('institutionCode',res.data.institutionCode)
                // localStorage.setItem('token',res.data.token)
                this.$common.setCache('institutionCode',res.data.institutionCode)
                this.$common.setCache('campusCode',res.data.campusCode)
                this.$common.setCache('token',res.data.token)
            }
            this.current = 1
            await this.getCourseData(this.year,this.month)
            this.getDetail()
            
        },
        async getToday() {
            let date = new Date()
            let y = date.getFullYear();
            let m = date.getMonth();
            let d = date.getDate();
            this.year = y
            this.month = m+1
            await this.getCourseData(y,m+1)
            this.selectDate = y+'-'+this.changeNum(m+1)+'-'+this.changeNum(d)
        },
        changeNum(num) {
            num = Number(num)
            if(num < 10) {
                return '0'+num
            }else {
                return num
            }
        },
        async getCourseData(year,month) {
            this.markDays = []
            year = parseInt(year)
            month = parseInt(month)
            // var startYear = month-1 >= 1 ? year : year -1
            // var startMonth = month-1 >= 1? month -1 : 12

            // var endYear = month+1 <= 12 ? year : year + 1
            // var endMonth = month+1 <= 12 ? month+1 : 1
            // var days = new Date(endYear,endMonth,0).getDate()

            let firstDayOfMonth = new Date(year, month - 1, 1).getDay(); // 当月第一天星期几
            let lastDateOfMonth = new Date(year, month, 0).getDate(); // 当月最后一天
            let lastDayOfLastMonth = new Date(year, month-1, 0).getDate(); // 上一月的最后一天
            let weekstart = 0;
            let startDay = (() => {
                // 周初有几天是上个月的
                if (firstDayOfMonth == weekstart) {
                return 0;
                } else if (firstDayOfMonth > weekstart) {
                return firstDayOfMonth - weekstart;
                } else {
                return 7 - weekstart + firstDayOfMonth;
                }
            })();
            let endDay = 7 - ((startDay + lastDateOfMonth) % 7); // 结束还有几天是下个月的
            var startYear = ''
            var startMonth = ''
            var startDate = ''
            var endYear = ''
            var endMonth = ''
            var endDate = ''
            if(startDay == 0) {
                startYear = year
                startMonth = month
                startDate = '01'
            }else {
                startYear = month - 1 >= 1 ? year : year - 1
                startMonth = month - 1 >= 1 ? this.changeNum(month - 1) : 12
                startDate = this.changeNum(lastDayOfLastMonth - startDay + 1)
            }

            if(endDay == 0) {
                endYear = year
                endMonth = month
                endDate = lastDateOfMonth
            }else {
                endYear = month + 1 <= 12 ? year : year + 1
                endMonth = month + 1 <= 12 ? this.changeNum(month + 1) : '01'
                endDate = this.changeNum(endDay)
            }

            var obj = {
                campusCode: this.campusCode,
                // teacherUid: '777193611413557248',
                // startDate: startYear+'-'+startMonth+'-'+startDate,
                // endDate: endYear+'-'+endMonth+'-'+endDate,
                startDate: startYear+'-'+this.changeNum(startMonth)+'-'+this.changeNum(startDate),
                endDate: endYear+'-'+this.changeNum(endMonth)+'-'+this.changeNum(endDate),
            }
            var res = await getCourseDataAPI(obj)
            if(res.resultCode == 200 ) {
                console.log('课表：',res)
                this.courseData = res.data
                if(res.data) {
                    for(var key in res.data) {
                        this.markDays.push({date: key,isSelf:res.data[key].isSelf})
                    }
                }
                
            }
        },
        setDate(val) {
            this.selectDate = val.date
        },
        clickItem(item) {
            // this.detail = item
            this.$router.push({name:'StuList',query: {childCourseId:item.id}})
            // this.stuListShow = true
        },
        stuListEvent(val) {
            if(val.type == 'close') {
                this.stuListShow = false
            }else if(val.type == 'ensure') {
                this.stuListShow = false
                this.getDetail()
            }
        },
        changeMonth(val) {
            this.year = val.year
            this.month = val.month
            this.getCourseData(val.year,val.month)
        },
        getDetail() {
            if(this.markDays.some(item => {return item.date == this.selectDate})) {
                var idList = this.courseData[this.selectDate].childCourseIdList.join(',')
                getCourseDetailsAPI({idList: idList}).then(res => {
                    console.log("课程详情：",res)
                    if(res.resultCode == 200) {
                        this.courseList = res.data
                    }
                })
            }else {
                this.courseList = []
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.empty {
    opacity: 0;
}
.common {
    background-color: #CFECFF;
}
.self {
    background-color: #DAF6F4;
}
.courseBox {
    width: 100%;
    height: 100%;
}
.top {
    position: relative;
    width: 100%;
    .campusBox {
        position: absolute;
        left: .15rem;
        top: 12px;
        font-weight: 500;
        font-size: 16px;
        color: #333843;
    }
    .icon {
        margin-left: 4px;
    }
}
.topImg {
    width: 100%;
}
.goToday {
    position: absolute;
    left: .15rem;
    bottom: 0px;
    width: 64px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #6985FF;
    font-size: 12px;
    color: #6985FF;
    text-align: center;
    line-height: 22px;
    box-sizing: border-box;
}
// .calendarBox {
// }
.courseList {
    flex: 1;
    overflow: auto;
    padding: 24px .12rem 12px;
}
.paddT {
    padding-top: 16px;
}
.spotBox {
    position: absolute;
    left:-19px;
    top: 0px;
    height: 100%;
}
.spot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #9EA8BA;
    
}
.attendanceStatusBox {
    position: absolute;
    top: 10px;
    right: 0px;
    width: 53px;
    height: 21px;
    background: rgba(255,255,255,0.6);
    border-radius: 50px 0px 0px 50px;
    font-size: 12px;
    color: #575D68;
}
.courseItem {
    width: 100%;
    .time {
        width: 40px;
        text-align: left;
        opacity: 0.8;
        // line-height: 106px;
        font-size: 12px;
    }
    .courseInfo {
        position: relative;
        flex: 1;
        border-left: 1px solid #ECEDF2;
        padding-left: 16px;
        box-sizing: border-box;
        
    }
    .infoBox {
        position: relative;
        padding: 10px 20px;
        box-sizing: border-box;
        // width: 296px;
        // height: 106px;
        border-radius: 12px;
    }
    .courseName {
        margin-bottom: 6px;
        font-size: 16px;
        line-height: 23px;
    }
    .infoText {
        font-size: 12px;
        line-height: 19px;
        opacity: 0.8;
        .attribute {
            min-width: 4em;
            margin-right: 12px;
        }
        .value {
            flex: 1;
        }
    }
}
.emptyBox {
    img {
        width: 165px;
        height: 114px;
        margin-top: 40px;
    }
    >div {
        font-size: 13px;
        color: #9EA8BA;
        line-height: 19px;
    }
}
</style>